export enum OperatorVehicleStatusEnum {
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected'
}
